<template>
    <div class="ctn">
        <img src="../../assets/Home/在线咨询.png" alt="" class="ctn1Img" @click="$router.push('/onlineService/Home')">
        <div class="ctn1White">
            <div class="ctn1Block1" @mouseenter="clickOne=true" @mouseleave="clickOne=false">
                <img src="../../assets/Home/联系客服黑.png" alt="" v-if="!clickOne" style="position: absolute;left: 8px;">
                <img src="../../assets/Home/联系客服蓝.png" alt="" v-if="clickOne" style="position: absolute;left: 8px;">
                <div :class="clickOne ? 'ctn1Text1' : 'ctn1Text1-s'">联系客服</div>
                <img src="../../assets/Home/专属商务经理.png" alt="" v-if="clickOne" style="position: absolute;right: 72px;height: 104px;top: -33px;">
            </div>
            <div class="ctn1Block1" @mouseenter="clicktwo=true" @mouseleave="clicktwo=false" style="top: 90px;">
                <img src="../../assets/Home/购买热线黑.png" alt="" v-if="!clicktwo" style="position: absolute;left: 8px;">
                <img src="../../assets/Home/购买热线蓝.png" alt="" v-if="clicktwo" style="position: absolute;left: 8px;">
                <div :class="clicktwo ? 'ctn1Text1' : 'ctn1Text1-s'">购买热线</div>
                <img src="../../assets/Home/购买热线.png" alt="" v-if="clicktwo" style="position: absolute;right: 72px;height: 90px;top: -20px;">
            </div>
            <div class="ctn1Block1" @mouseenter="clickThree=true" @mouseleave="clickThree=false" @click="openPDF()" style="top: 156px;">
                <img src="../../assets/Home/帮助文档黑.png" alt="" v-if="!clickThree" style="position: absolute;left: 8px;">
                <img src="../../assets/Home/帮助文档蓝.png" alt="" v-if="clickThree" style="position: absolute;left: 8px;">
                <div :class="clickThree ? 'ctn1Text1' : 'ctn1Text1-s'">帮助文档</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "",
    data(){
        return {
            clickOne:false,
            clicktwo:false,
            clickThree:false,
        };
    },
    methods:{
        openPDF(){
            window.open("https://files.jl1mall.com/jl1store/document/在线地图访问常见问题帮助文档.pdf")
        }
    },

    mounted(){},
};
</script>
<style scoped>
.ctn{
    position: fixed;
    width: 56px;
    height: 342px;
    top: calc(50% - 130px);
    right: 50px;
    z-index: 11000;
}
.ctn1Img{
    position: absolute;
    width: 56px;
    top: 0;
    cursor: pointer;
}
.ctn1White{
    position: absolute;
    top: 120px;
    width: 56px;
    height: 222px;
    /* height: 165px; */
    background: #FFFFFF;
    box-shadow: 0px 0px 1px 0px rgba(0,0,0,0.5);
    border-radius: 24px;
}
.ctn1Block1{
    position: absolute;
    top: 24px;
    left: 8px;
    width: 40px;
    height: 42px;
    cursor: pointer;
}
.ctn1Text1{
    position: absolute;
    top: 28px;
    width: 40px;
    height: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: rgba(24, 144, 255, 1);
    line-height: 14px;
    text-align: center;
}
.ctn1Text1-s{
    position: absolute;
    top: 28px;
    width: 40px;
    height: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #000000;
    line-height: 14px;
    text-align: center;
}
</style>
  